<div class="bp-info-dialog relative flex flex-col w-full">

    <!-- Header -->
    <div class="bp-info-dialog__header">
        <div class="bp-info-dialog__header-text">
            <h2 class="bp-info-dialog__title">Informações da previsão</h2>
            <p class="bp-info-dialog__subtitle">
                Período, fonte dos dados e divisores usados no último cálculo da previsão orçamentária.
            </p>
        </div>
        <button type="button"
                mat-icon-button
                class="bp-info-dialog__close"
                (click)="matDialogRef.close()"
                [matTooltip]="'Fechar'">
            <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <!-- Body -->
    <div class="bp-info-dialog__body">

        <div *ngIf="loading" class="flex justify-center py-6">
            <mat-progress-spinner [diameter]="36" [strokeWidth]="3" [mode]="'indeterminate'"></mat-progress-spinner>
        </div>

        <ng-container *ngIf="!loading">

            <!-- Período -->
            <div class="bp-info-dialog__section">
                <label class="bp-info-dialog__label">Período da previsão</label>
                <div class="bp-info-dialog__value">
                    {{formatDate(periodStart)}} à {{formatDate(periodEnd)}}
                    <span *ngIf="divisors.period_months" class="bp-info-dialog__muted">
                        ({{divisors.period_months}} {{divisors.period_months === 1 ? 'mês' : 'meses'}})
                    </span>
                </div>
            </div>

            <div *ngIf="error" class="bp-info-dialog__notice bp-info-dialog__notice--error">
                Não foi possível carregar as informações do cálculo.
            </div>

            <div *ngIf="!error && !metadata" class="bp-info-dialog__notice">
                Esta previsão foi calculada antes do registro das informações do cálculo.
                Recarregue a previsão para ver a fonte dos dados, os meses com movimentação e os divisores usados.
            </div>

            <ng-container *ngIf="metadata">

                <!-- Fonte -->
                <div class="bp-info-dialog__section">
                    <label class="bp-info-dialog__label">Fonte dos dados</label>
                    <div class="bp-info-dialog__text">{{sourceLabel}}</div>
                </div>

                <!-- Trechos -->
                <div class="bp-info-dialog__section">
                    <label class="bp-info-dialog__label">Meses com movimentação (despesas)</label>

                    <div *ngFor="let segment of segments" class="bp-info-dialog__card">
                        <div class="bp-info-dialog__card-head">
                            <span class="bp-info-dialog__card-title">{{segment.sourceLabel}}</span>
                            <span class="bp-info-dialog__muted">{{formatDate(segment.start)}} à {{formatDate(segment.end)}}</span>
                        </div>
                        <div class="bp-info-dialog__text">
                            <ng-container *ngIf="segment.monthsWithMovement !== null && !segment.estimated; else noCount">
                                {{segment.monthsWithMovement}} de {{segment.months}} {{segment.months === 1 ? 'mês' : 'meses'}} com movimentação
                            </ng-container>
                            <ng-template #noCount>
                                Contagem de meses indisponível<ng-container *ngIf="segment.estimated">:
                                    {{segment.monthsWithMovement === 0
                                        ? 'sem realizado no trecho, nenhum mês considerado'
                                        : 'considerados os ' + segment.monthsWithMovement + ' meses do trecho'}}</ng-container>
                            </ng-template>
                        </div>
                        <div *ngIf="segment.monthList.length" class="bp-info-dialog__months">
                            <span *ngFor="let month of segment.monthList"
                                  class="bp-info-dialog__month"
                                  [class.bp-info-dialog__month--moved]="month.moved && !month.failed"
                                  [class.bp-info-dialog__month--failed]="month.failed"
                                  [matTooltip]="month.failed ? 'Falha ao consultar a Live: considerado com movimentação' : (month.moved ? 'Com movimentação' : 'Sem movimentação')">
                                {{month.label}}
                            </span>
                        </div>
                    </div>

                    <div *ngIf="failedMonths.length" class="bp-info-dialog__hint bp-info-dialog__hint--warn">
                        A consulta à Live falhou em {{failedMonths.join(', ')}}; esses meses foram considerados com movimentação.
                    </div>
                </div>

                <!-- Divisores -->
                <div class="bp-info-dialog__section">
                    <label class="bp-info-dialog__label">Como os valores mensais foram calculados</label>
                    <ul class="bp-info-dialog__list">
                        <li>
                            <strong>Média mensal realizada</strong> = realizado ÷ <strong>{{divisors.accomplished_months}}</strong>
                            <span *ngIf="!divisors.fallback">(meses com movimentação)</span>
                            <span *ngIf="divisors.fallback">(meses do período; contagem de meses com movimentação indisponível)</span>
                        </li>
                        <li><strong>Valor mensal projetado</strong> = média mensal realizada × (1 + índice da linha)</li>
                        <li><strong>Média mensal orçada</strong> = orçado ÷ <strong>{{divisors.period_months}}</strong> (meses do período)</li>
                        <li><strong>Valor período projetado</strong> = valor mensal projetado × <strong>{{divisors.period_months}}</strong> (meses do período)</li>
                        <li *ngIf="divisors.approved_budget">O orçado vem da previsão aprovada na última assembleia do condomínio.</li>
                    </ul>
                </div>

                <!-- Saldo -->
                <div class="bp-info-dialog__section">
                    <label class="bp-info-dialog__label">Saldos</label>
                    <div class="bp-info-dialog__text">
                        Posição {{details.balance?.source === 'live' ? 'da Live' : 'da base antiga'}} em {{formatDate(details.balance?.reference_date)}}
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>

    <!-- Footer -->
    <div class="bp-info-dialog__footer">
        <span *ngIf="metadata" class="bp-info-dialog__hint">
            Calculado em {{metadata.created_at | date: 'dd/MM/yy HH:mm'}}
        </span>
        <button type="button"
                mat-stroked-button
                (click)="matDialogRef.close()">
            Fechar
        </button>
    </div>

</div>
